const clickwrapContractPage = [
    {
        selector: '[data-react="clickwrapContractPage"]',
        path: { filename: 'clickwrapContractPage' },
    },
];

export { clickwrapContractPage };
